import { render } from "./SelectCategoriesSelected.vue?vue&type=template&id=4b7fa28d&scoped=true&ts=true"
import script from "./SelectCategoriesSelected.vue?vue&type=script&lang=ts"
export * from "./SelectCategoriesSelected.vue?vue&type=script&lang=ts"

import "./SelectCategoriesSelected.vue?vue&type=style&index=0&id=4b7fa28d&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7fa28d"]])

export default __exports__